module.exports = __webpack_public_path__ + "static/media/Angel-Particles.4d7f32bb.png";